import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import FeedbackForm from '../common/feedback_form/feedback_form.component';

const Error = (props) => {
  const [fbModalVisible, setFbModalVisible] = useState(false);

  return (
    <>
      <Modal show={props.show} centered={true} className="broker-error">
        <Modal.Body className="content">
          <FontAwesomeIcon icon={faTimesCircle} color="#E64444" size="2x" />
          <h5 className="title mt-4">Error</h5>
          <p className="info">{props.text}</p>
          <button
            type="button"
            className="err-retry"
            onClick={() => {
              props.setShow(false);
              props.onRetry();
            }}
          >
            Retry
          </button>
          <p className="help mt-5">
            Need help? Please get in touch{' '}
            <span
              className="role-btn"
              onClick={() => {
                props.setShow(false);
                setFbModalVisible(true);
              }}
            >
              here
            </span>
          </p>
        </Modal.Body>
        <div
          className="close-btn"
          onClick={() => {
            props.setShow(false);
          }}
        >
          &#10006;
        </div>
      </Modal>
      <FeedbackForm show={fbModalVisible} setShow={setFbModalVisible} />
    </>
  );
};

export default Error;
